module.exports = __webpack_public_path__ + "static/media/CircularStd-BlackItalic.06bbad3b.eot";